// extracted by mini-css-extract-plugin
export default {"tx":"_8fce8757aa","line":"f703f0e970"};